import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import fixTrackVars from '../../helpers/data_track_prop_map';

const Media = ({ img, url, children, track, title = '', altText = '' }) => (
  <div className="media">
    {img && (
      <a
        href={url}
        aria-label={title}
        className="image"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...fixTrackVars(track)}
      >
        <LazyLoadImage alt={altText} src={img} />
      </a>
    )}

    {children}
  </div>
);

Media.propTypes = {
  img: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  track: PropTypes.object.isRequired,
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  altText: PropTypes.string,
};

PropTypes.defaultProps = {
  title: '',
  altText: '',
};

export default Media;
